import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
	feeds: [],
	feedsMeta: {},
	lastFeedPage: null,
	lastScrolling: 0,
	postLikedUsers: [],
	lastcursor: null,
	currentCusror: 0,
};

const feedsFollowingStore = (set: any) => ({
	...initialState,

	setFeeds: (data: any) => set((state: any) => ({ ...state, feeds: data })),
	setFeedsMeta: (data: any) => set((state: any) => ({ ...state, feedsMeta: data })),
	setLastFeedPage: (data: any) => set((state: any) => ({ ...state, lastFeedPage: data })),
	setLastScrolling: (data: any) => set((state: any) => ({ ...state, lastScrolling: data })),
	setLastcursor: (data: number) => set((state: any) => ({ ...state, lastcursor: data })),
	setCurrentCursor: (data: number) => set((state: any) => ({ ...state, currentCusror: data })),

	updateIsLike: (postId: string | number, isLike: boolean) =>
		set((state: any) => ({
			feeds: state.feeds.map((feed: any) => (feed.postId === postId ? { ...feed, isLike } : feed)),
		})),

	updateTotalLikes: (postId: number, totalLikes: number) =>
		set((state: any) => ({
			feeds: state.feeds.map((feed: any) =>
				feed.postId === postId ? { ...feed, totalLikes } : feed,
			),
		})),

	updateTotalComments: (postId: number, totalComments: number) =>
		set((state: any) => ({
			feeds: state.feeds.map((feed: any) =>
				feed.postId === postId ? { ...feed, totalComments } : feed,
			),
		})),

	updateIsConnected: (postId: number, isConnected: number) =>
		set((state: any) => ({
			feeds: state.feeds.map((feed: any) =>
				feed.postId === postId ? { ...feed, isConnected } : feed,
			),
		})),

	setPostLikedUsers: (data: any) =>
		set(() => ({
			postLikedUsers: Array.isArray(data) ? data : [],
		})),

	removeFeedByPostId: (postId: number) =>
		set((state: any) => ({
			feeds: state.feeds.filter((feed: any) => feed.postId !== postId),
		})),

	removeFeedByUserId: (userId: number) =>
		set((state: any) => ({
			feeds: state.feeds.filter((feed: any) => feed.userId !== userId),
		})),

	resetFeeds: () => set({ ...initialState }),
});

const useFeedsFollowingStore = create(devtools(feedsFollowingStore));

export const {
	setFeeds: setFollowingFeeds,
	setFeedsMeta: setFollowingFeedsMeta,
	setLastFeedPage: setFollowingLastFeedPage,
	setLastScrolling: setFollowingLastScrolling,
	updateIsLike: updateFollowingIsLike,
	updateTotalLikes: updateFollowingTotalLikes,
	updateTotalComments: updateFollowingTotalComments,
	updateIsConnected: updateFollowingIsConnected,
	setPostLikedUsers: setFollowingPostLikedUsers,
	removeFeedByPostId: removeFollowingFeedByPostId,
	removeFeedByUserId: removeFollowingFeedByUserId,
	resetFeeds: resetFollowingFeeds,
	setLastcursor: setFollowingLastcursor,
	setCurrentCursor: setFollowingCurrentCursor,
} = useFeedsFollowingStore.getState();

export default useFeedsFollowingStore;
